/**
 * Helper'ы для построения URL'ов проекта в ленте новостей.
 *
 * Везде, где есть выбор «использовать UUID или человеко-читаемый код проекта»,
 * предпочитаем второй — URL'ы вида `/project/PC02/news/...` гораздо понятнее
 * для пользователей и share-link'ов, чем `/project/c0000001-...-0006/...`.
 *
 * Backend (ProjectsService.resolveProjectId, PermissionEvaluationService.resolveProjectUuid)
 * принимает оба формата, так что фронт может свободно использовать ключ.
 */

/** Сегмент проекта в URL: предпочитаем issue_key_prefix, fallback на UUID. */
export function projectUrlSegment(
  projectKey: string | null | undefined,
  projectId: string,
): string {
  const key = (projectKey ?? '').trim();
  return key ? key : projectId;
}

/** URL ленты конкретного проекта. */
export function projectFeedUrl(
  projectKey: string | null | undefined,
  projectId: string,
): string {
  return `/project/${encodeURIComponent(projectUrlSegment(projectKey, projectId))}`;
}

/** URL детального экрана новости. */
export function newsArticleUrl(
  projectKey: string | null | undefined,
  projectId: string,
  documentId: string,
): string {
  return `/project/${encodeURIComponent(projectUrlSegment(projectKey, projectId))}/news/${encodeURIComponent(documentId)}`;
}
